<template>
  <div class="i-list">
    <template v-if="items">
      <div v-for="(item, index) in items" :key="index">
        <slot :item="item"></slot>
      </div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'list',
  props: {
    items: {
      type: Array,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/list/list.vue